// extracted by mini-css-extract-plugin
module.exports = {"root":"EditCommentForm-root-65ca088b19f25316df517355283cb845"};